import { z } from "zod";

export const CpcCreateSimulationResponseSchema = z.object({
  success: z.boolean(),
});
export type CpcCreateSimulationResponse = z.infer<typeof CpcCreateSimulationResponseSchema>;

export const CpcVerifyWalletResponseSchema = z.object({
  match: z.boolean(),
  simulationWalletAddress: z.string(),
});
export type CpcVerifyWalletResponse = z.infer<typeof CpcVerifyWalletResponseSchema>;
